export default __webpack_public_path__ + "static/media/order-at-kiosk.9b67d7e0.jpg";